module.exports = __webpack_public_path__ + "static/media/sign-up-img-5.8a32a4b6.png";